import React from 'react';
import {isExpanded, isNotExpanded} from './state/rightMenuExpanded';
import {connect} from 'react-redux';
import {postMata} from "./api";
import {setSquaresHash} from "./state/tableSquaresState";
import {setCirclesHash} from "./state/tableCirclesState";
import {setMataUrl} from "./state/mataUrl";


class RightMenuButton extends React.Component {
    constructor(props) {
        super(props);

        this.updateStore = (e, id) => {
            if (e.currentTarget.classList.contains('active-button')) {
                this.props.isExpanded(id);
            }
            else {
                this.props.isNotExpanded();
            }
        };

        this.setUrl = (d) => {
            let url = document.location.href.split('/');
            if (url[url.length - 1] === 'wirtualna-mata-do-kodowania') {
                url[url.length] = d.mata.hash;
            }
            else {
                url[url.length - 1] = d.mata.hash;
            }
            url = url.join('/');
            this.props.setMataUrl('www.mata.uczymydzieciprogramowac.pl/pl/' + d.mata.hash);
            window.history.pushState('', '', url);
        };

        this.postMata = () => {
            let mata = {};
            if (this.props.activeTable === 'SQUARES' && this.props.rightMenuExpanded.type === 'IS_NOT_EXPANDED') {
                mata = this.props.squareState;
                postMata(mata).then((d) => {
                    this.props.setSquaresHash(d.mata.hash);
                    this.setUrl(d);
                    let newUrl = document.location.href;
                    document.querySelector('[property="og:url"]').setAttribute('content', newUrl);
                    newUrl = newUrl.split('/');
                    newUrl.splice(newUrl.length - 1, 0, 'img');
                    document.querySelector('[property="og:image"]').setAttribute('content', newUrl.join('/'))
                });
            }
            else if (this.props.activeTable === 'CIRCLES' && this.props.rightMenuExpanded.type === 'IS_NOT_EXPANDED') {
                mata = Object.assign({},this.props.circlesState, {commands: []});
                postMata(mata).then((d) => {
                    this.props.setCirclesHash(d.mata.hash);
                    this.setUrl(d)
                });
            }
        };

        this.toggleActiveClasses = e => {
            let activeButton = document.getElementsByClassName('active-button')[0];
            if (activeButton) {
                activeButton.classList.remove('active-button');
            }

            let target = e.currentTarget;
            if (activeButton !== target) {
                target.classList.toggle('active-button');
            }

            let thHeight = document.getElementsByClassName('single-grid-th')[0].clientHeight + 'px';
            let details = target.offsetParent.nextSibling;
            let buttonsContainer = document.getElementById('rightMenuButtonsContainer');
            if (this.props.activeTable === 'CIRCLES') {
                thHeight = document.getElementById('rightMenuButtonsContainer').top;
            }
            details.style.top = thHeight;
            if (activeButton === e.currentTarget) {
                details.classList.remove('show');
                buttonsContainer.classList.remove('expand-left');
            }
            else {
                details.classList.add('show');
                buttonsContainer.classList.add('expand-left');
            }
        };

        this.activeButtonAction = e => {
            let id = this.props.text.toLowerCase();

            this.toggleActiveClasses(e);
            this.updateStore(e, id);
            this.postMata(this.props.activeTable);
        }
    }

    render() {
        return (
            <button className="right-menu-button" onClick={this.activeButtonAction}>
                <div className="button-content">
                    <img className="right-menu-button-img" src={this.props.src} alt={this.props.text}/>
                    <p>{this.props.text}</p>
                </div>
            </button>
        )
    }
}

export default connect(
    state => ({
        rightMenuExpanded: state.rightMenuExpanded,
        activeTable: state.activeTable,
        squareState: state.squaresState,
        circlesState: state.circlesState,
    }),
    {isExpanded, isNotExpanded, setSquaresHash, setCirclesHash, setMataUrl}
)(RightMenuButton)


// WEBPACK FOOTER //
// ./src/RightMenuButton.js